import {NFLookupCatalog} from "./NFLookupCatalog";
import {AppEntities} from "../../../config/entities";
import {NFLookupCatalogColumn} from "./NFLookupCatalogColumn";
import React from "react";

interface IProps {
    title?: string;
    fieldName: string;
    required?: boolean;
    showBorder?: boolean;
    selectedCatalog?: boolean;
    setSelectedCatalog?: (value: boolean) => void;
    vendorCustomerId?: string;
}

export const NFLookupContract = ({
                                     title,
                                     fieldName,
                                     required,
                                     showBorder,
                                     selectedCatalog,
                                     setSelectedCatalog,
                                     vendorCustomerId
                                 }: IProps) => {
    const loadData = async (searchText: string | undefined) => {
        console.log("vendorCustomerId", vendorCustomerId)
        return await AppEntities.Contract.getDataService().GetAllByVendorCustomer(searchText, vendorCustomerId);
    };

    return (
        <>
            <NFLookupCatalog
                fieldName={fieldName}
                title={title}
                entity={AppEntities.Contract}
                serverData={loadData}
                required={required}
                showBorder={showBorder}
                selectedCatalog={selectedCatalog}
                setSelectedCatalog={setSelectedCatalog}
            >
                <NFLookupCatalogColumn fieldName={"id"} caption={"Id"}/>
                <NFLookupCatalogColumn fieldName={"name"} caption={"Name"}/>
                <NFLookupCatalogColumn fieldName={"tin"} caption={"TIN"}/>
            </NFLookupCatalog>
        </>
    );
};
